import { createFileRoute, redirect } from "@tanstack/react-router";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/de/gebrauchtwagen-kaufen-deutschland/")({
  head: () => routeHead("/de/gebrauchtwagen-kaufen-deutschland/"),
  beforeLoad: () => {
    throw redirect({ href: "/de/cars", statusCode: 301, replace: true });
  },
});
